//PJQProjectWallAdmin-ProjectContacts
var isAddProjectContactsContext = false;

function initProjectContacts() {
	PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALLADMIN, 'ProjectContacts', {
		isOldModule: true,
		isJsRender: true
	}), $('#project-contacts'), null, function () {
		initProjectContactsGrid();
		isProjectContactsInit = true;
	});
}

var projectContactsGridMenu,
	projectContactsGrid,
	projectContactsGridTbSearch,
	projectContactsGridTbActions;

function initProjectContactsGrid() {
	projectContactsGridMenu = new dhtmlXMenuObject('gridMenu');
	projectContactsGridMenu.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/");
	projectContactsGridMenu.renderAsContextMenu();
	projectContactsGridMenu.attachEvent("onClick", function (id, zoneId) {
		var rowId = zoneId.split('_')[0];
		if (id == 'viewEdit') {
			new PJQ.ajax.Request({
				endpoint: "/Contact/GetContactInfoAdmin",
				isPascal: true,
				data: {
					contactId: parseInt(rowId)
				}
			}).post().done(function (data) {
				EditContactC(data);
			}).fail(function () {
			});
		}
		else if (id == 'delete') {
			PanteraScript.PanteraScriptService.DeleteProjectContactsProjectManagement(pjqSessionId, project.ProjectId, rowId, DeleteProjectContactsProjectManagementC, onScriptError);
		}
		else if (id == 'enable_seat') {
			addUserSeats(rowId);
		}
		else if (id == 'disable_seat') {
			deleteUserSeats(rowId);
		}
	});
	projectContactsGridMenu.loadXMLString(createGridMenuXMLString('viewEdit|delete'));
	if (settings.UserSeatLimit > 0) {
		projectContactsGridMenu.addNewChild(projectContactsGridMenu.topId, 10, "enable_seat", "Enable Seat", false, "");
		projectContactsGridMenu.addNewChild(projectContactsGridMenu.topId, 11, "disable_seat", "Disable Seat", false, "");
	}

	projectContactsGrid = new dhtmlXGridObject('projectContactsGrid');
	projectContactsGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	projectContactsGrid.setSkin(pjqGridTheme);
	projectContactsGrid.enableAutoHeight(true);
	projectContactsGrid.enablePaging(true, 10, 3, "projectContactsGridPaging", true);
	projectContactsGrid.setPagingSkin("toolbar", "dhx_web");
	projectContactsGrid.setDragBehavior('complex');
	projectContactsGrid.setDelimiter('|');
	projectContactsGrid.enableContextMenu(projectContactsGridMenu);
	projectContactsGrid.loadXML(getGridURLProjectContacts());
	projectContactsGrid.init();
	projectContactsGrid.attachEvent("onXLE", function (grid_obj, count) {
		projectContactsGridTbActions.disableItem('edit');
		projectContactsGridTbActions.disableItem('delete');
		if (settings.UserSeatLimit > 0)
			projectContactsGridTbActions.disableItem('toggle_seats');

	});
	projectContactsGrid.attachEvent("onRowSelect", function (id, ind) {
		if (projectContactsGrid.getUserData(id, 'contactType') == 'pm') {
			projectContactsGridTbActions.disableItem('edit');
			projectContactsGridTbActions.hideItem('edit');
			projectContactsGridTbActions.hideItem('edit_sep');
		}
		else {
			projectContactsGridTbActions.showItem('edit');
			projectContactsGridTbActions.enableItem('edit');
			projectContactsGridTbActions.showItem('edit_sep');
		}
		return true;
	});

	projectContactsGrid.attachEvent("onBeforeContextMenu", function (id, ind, obj) {
		projectContactsGrid.selectRowById(id);
		if (settings.UserSeatLimit > 0) {
			projectContactsGridMenu.hideItem('enable_seat');
			projectContactsGridMenu.hideItem('disable_seat');
		}

		if (projectContactsGrid.getUserData(id, 'contactType') == 'pm') {
			projectContactsGridMenu.hideItem('viewEdit');
			projectContactsGridMenu.hideItem('delete');
		}
		else {
			projectContactsGridMenu.showItem('viewEdit');
			projectContactsGridMenu.showItem('delete');
			if (settings.UserSeatLimit > 0) {
				if (projectContactsGrid.cells(id, 6).getValue() == 'Yes')
					projectContactsGridMenu.showItem('disable_seat');
				else if (projectContactsGrid.cells(id, 6).getValue() == 'No')
					projectContactsGridMenu.showItem('enable_seat');
			}
		}
		return true;
	});

	projectContactsGrid.attachEvent("onCheckbox", function (id, ind, state) {
		if (getCheckedPC().length > 0)
			projectContactsGridTbActions.enableItem('delete');
		else
			projectContactsGridTbActions.disableItem('delete');

		afterCheckedPC();

		return true;
	});

	projectContactsGrid.attachEvent("onRowDblClicked", function (rId, cInd) {
		let rowId = parseInt(rId);
		if (rowId > 0) {
			new PJQ.ajax.Request({
				endpoint: "/Contact/GetContactInfoAdmin",
				isPascal: true,
				data: {
					contactId: rowId
				}
			}).post().done(function (data) {
				EditContactC(data);
			}).fail(function () {
			});
		}
	});

	projectContactsGridTbSearch = new dhtmlXToolbarObject("projectContactsGridToolbarSearch");
	projectContactsGridTbSearch.setSkin("dhx_web");
	projectContactsGridTbSearch.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	projectContactsGridTbSearch.addInput('searchFor', 0, '', 400);
	projectContactsGridTbSearch.addSeparator('search_sep', 1);
	projectContactsGridTbSearch.addButton("search", 2, "Search/Refresh", "action_search.gif", "");
	projectContactsGridTbSearch.attachEvent("onClick", function (id) {
		switch (id) {
			case 'search':
				refreshGridProjectContacts();
				break;
		}
	});

	projectContactsGridTbActions = new dhtmlXToolbarObject("projectContactsGridToolbarActions");
	projectContactsGridTbActions.setSkin("dhx_web");
	projectContactsGridTbActions.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");

	if (settings.IsProjectManagement) {
		var addOpts = [
			['addVA', 'obj', 'from Address Book', ''],
			['add_contacts_itb', 'obj', 'from Invititation to Bid', '']
		];
		projectContactsGridTbActions.addButtonSelect("add_default", 0, "Add Vendors/Architects", addOpts, "AddContact.png", "AddContactD.png");
		//projectContactsGridTbActions.setListOptionSelected("add_default", addOpts[0][0]);
	}
	else {
		projectContactsGridTbActions.addButton("addPM", 0, "Add Project Managers", "new.gif", "new_dis.gif");
		projectContactsGridTbActions.addButton("addVA", 1, "Add Vendors/Architects", "new.gif", "new_dis.gif");
	}
	projectContactsGridTbActions.addSeparator('edit_sep', 2);
	projectContactsGridTbActions.addButton("edit", 3, "View/Edit Contact", "edit.jpg", "editd.jpg");
	projectContactsGridTbActions.addSeparator('delete_sep', 4);
	projectContactsGridTbActions.addButton("delete", 5, "Delete Checked", "Delete.png", "DeleteD.png");

	if (settings.UserSeatLimit > 0) {
		projectContactsGridTbActions.addSpacer("delete");
		projectContactsGridTbActions.addButton("toggle_seats", 7, "Toggle Checked Seats", "", "");
		projectContactsGridTbActions.disableItem('toggle_seats');
	}

	projectContactsGridTbActions.disableItem('edit');
	projectContactsGridTbActions.attachEvent("onClick", function (id) {
		switch (id) {
			case 'addVA':
				projectContactsGridTbActions.setListOptionSelected("add_default", null);
				var redirUrl = '/Default.aspx?tabId=' + settings.AddressBookTabId.toString() + '&ap2=' + pjqSessionId + '&v=' + gridITBGroupBy + '&pc=true';
				window.location.href = redirUrl;
				break;
			case 'addPM':
				initAddProjectManagersDialog();
				break;
			case 'add_contacts_itb':
				projectContactsGridTbActions.setListOptionSelected("add_default", null);
				initAddPCFromITB(true);
				break;
			case 'edit':
				new PJQ.ajax.Request({
					endpoint: "/Contact/GetContactInfoAdmin",
					isPascal: true,
					data: {
						contactId: parseInt(projectContactsGrid.getSelectedRowId())
					}
				}).post().done(function (data) {
					EditContactC(data);
				}).fail(function () {
				});
				break;
			case 'delete':
				PanteraScript.PanteraScriptService.DeleteProjectContactsProjectManagement(pjqSessionId, project.ProjectId, getCheckedPC(), DeleteProjectContactsProjectManagementC, false);
				break;
			case 'toggle_seats':
				toggleUserSeats();
				break;
		}
	});

	jQuery('#projectContactsGridToolbarSearch > div.float_left > div:nth-child(1) > input').keypress(function (event) {
		if (event.which == 13) {
			event.preventDefault();
			refreshGridProjectContacts();
		}
	});
}

function afterCheckedPC() {
	if (settings.UserSeatLimit == 0)
		return;

	var vendorCount = 0;
	for (var i = 0; i < projectContactsGrid.getRowsNum(); i++) {
		if (projectContactsGrid.cells2(i, 0).getValue() == 1) {
			var pcId = parseInt(projectContactsGrid.getRowId(i).toString());
			if (pcId > 0)
				vendorCount++;
		}
	}
	if (vendorCount == 0)
		projectContactsGridTbActions.disableItem('toggle_seats');
	else
		projectContactsGridTbActions.enableItem('toggle_seats');
}

function getCheckedPC() {
	var delString = "";
	for (var i = 0; i < projectContactsGrid.getRowsNum(); i++) {
		if (projectContactsGrid.cells2(i, 0).getValue() == 1) {
			var pcId = projectContactsGrid.getRowId(i).toString();
			if (pcId && pcId.length > 0) {
				if (delString.length > 0)
					delString += ',';
			}
			delString += pcId;
		}
	}

	return delString;
}

function DeleteProjectContactsProjectManagementC(response) {
	refreshGridProjectContacts();
}

function getGridURLProjectContacts() {
	var response = '/DesktopModules/PJQProjectWallAdmin/GetPCGrid.aspx?sessionId=' + pjqSessionId;

	if (projectContactsGridTbSearch != null) {
		var projectContactsSearchFor = projectContactsGridTbSearch.getValue('searchFor').trim();
		if (projectContactsSearchFor.length > 0)
			response += '&s=' + projectContactsSearchFor;
	}

	return response;
}

function refreshGridProjectContacts() {
	projectContactsGrid.clearAndLoad(getGridURLProjectContacts());
}

function eXcell_projectcontactinfo(cell) { // contact info
	if (cell) { //default pattern, just copy it
		this.cell = cell;
		this.grid = this.cell.parentNode.grid;
	}
	this.edit = function () {
	}
	//read-only cell doesn't have edit method
	this.isDisabled = function () {
		return true;
	} // the cell is read-only, that's why it is always in the disabled state
	this.setValue = function (val) {

		var parts = val.split("|||");
		var title = parts[0];
		if (!title)
			title = parts[6];

		var rowCount = 6;
		if (parts[4])
			rowCount++;
		if (parts[5])
			rowCount++;
		if (parts[6])
			rowCount++;
		if (parts[7])
			rowCount++;
		if (parts[8])
			rowCount++;

		if (parts.length > 14)
			rowCount += (parts.length - 16) / 2;

		var icons = '&nbsp;';
		var iconsClass = 'ci-icon-hidden';

		var template = "<table border='0' class='contact-info-table' onclick='ProjectContactInfoClick(event, this);' oncontextmenu='ProjectContactInfoContext(event, this);'>";
		template = template + "<tr><td class='" + iconsClass + "' nowrap='nowrap' valign='top' rowspan='" + rowCount.toString() + "'>" + icons + "</td><td class='company-name' colspan='2'>" + parts[0] + "</td></tr>";
		if (parts[2])
			template = template + "<tr><td colspan='2'>" + parts[1] + " (" + parts[2] + ")</td></tr>";
		else
			template = template + "<tr><td colspan='2'>" + parts[1] + "</td></tr>";

		template = template + "<tr><td class='pjq-field-label'>Phone:</td><td >" + parts[3] + "</td></tr>";
		if (parts[6])
			template = template + "<tr><td class='pjq-field-label'>Email</td><td class='company-email'><a href='mailto:" + parts[6] + "'>" + parts[6] + "</a></td></tr>";
		template = template + "<tr><td colspan='2' class='show-details'><a href='javascript:void(0)' onclick='ShowDetailsPC(this, " + this.cell.parentNode.idd + "); event.preventDefault();'>Show More...</a></td></tr>";

		if (parts[4])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Fax</td><td class='pjq-hidden hideable'>" + parts[4] + "</td></tr>";
		if (parts[5])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Cell</td><td class='pjq-hidden hideable'>" + parts[5] + "</td></tr>";
		if (parts[7])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Address 1</td><td class='pjq-hidden hideable'>" + parts[7] + "</td></tr>";
		if (parts[8])
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>Address 2</td><td class='pjq-hidden hideable'>" + parts[8] + "</td></tr>";

		var location = parts[9];
		if (parts[10]) {
			if (location)
				location = location + ', ';

			location = location + parts[10];
		}
		if (parts[11]) {
			if (location)
				location = location + ' ';

			location = location + parts[11];
		}
		if (parts[12]) {
			if (location)
				location = location + ' ';

			location = location + parts[12];
		}
		if (location)
			template = template + "<tr><td class='pjq-field-label pjq-hidden hideable'>City, State, Zip</td><td class='pjq-hidden hideable'>" + location + "</td></tr>";

		template = template + "<tr><td colspan='2' class='hide-details pjq-hidden'><a href='javascript:void(0)' onclick='HideDetailsPC(this, " + this.cell.parentNode.idd + "); event.preventDefault();'>Show Less...</a></td></tr>";
		template = template + "</table>";
		this.setCValue(template);
	}
}

eXcell_projectcontactinfo.prototype = new eXcell; // nest all other methods from base class

function ProjectContactInfoClick(ev, sender) {
	projectContactsGrid.clearSelection();
	var cell = jQuery(sender).parent();
	cell.trigger({
		type: 'click',
		button: 2
	});
}

function ProjectContactInfoContext(ev, sender) {
	/*
	projectContactsGrid.clearSelection();
	var cell = jQuery(sender).parent();
	cell.next().trigger({
	    type: 'click',
	    button: 0
	});
	cell.trigger({
	    type: 'mousedown',
	    button: 2
	}).trigger({
	    type: 'mouseup'
	});

	var contextMenu = cmITB_P;
	if (gridITBGroupBy == 'view_message')
	    contextMenu = cmITB_PMR;

	contextMenu.showContextMenu(ev.pageX, ev.pageY);
	*/
}

function ShowDetailsPC(sender, rowId) {
	var g = jQuery(sender).parent().parent().parent().parent().parent().parent()[0].grid;
	var sg = g.cells(rowId, 0);
	if (sg && sg.isOpen && sg.isOpen())
		sg.close();
	else
		sg = null;
	jQuery("td.hideable", jQuery(sender).parent().parent().parent()).removeClass("pjq-hidden");
	jQuery("td.show-details", jQuery(sender).parent().parent().parent()).addClass("pjq-hidden");
	jQuery("td.hide-details", jQuery(sender).parent().parent().parent()).removeClass("pjq-hidden");
	if (sg) {
		sg.open();
	}
	g.setSizes();
	return false;
}

function HideDetailsPC(sender, rowId) {
	var g = jQuery(sender).parent().parent().parent().parent().parent().parent()[0].grid;
	var sg = g.cells(rowId, 0);
	if (sg && sg.isOpen && sg.isOpen())
		sg.close();
	else
		sg = null;
	jQuery("td.hideable", jQuery(sender).parent().parent().parent()).addClass("pjq-hidden");
	jQuery("td.show-details", jQuery(sender).parent().parent().parent()).removeClass("pjq-hidden");
	jQuery("td.hide-details", jQuery(sender).parent().parent().parent()).addClass("pjq-hidden");
	if (sg) {
		sg.open();
	}
	g.setSizes();
	return false;
}

function initAddPCFromITB(init) {
	isAddProjectContactsContext = init;
	if (init) {
		if (gridITB != null)
			gridITB.uncheckAll();

		tbITB.hideItem('new');
		tbITB.hideItem('sep2');
		tbITB.hideItem('add_default');
		tbITB.hideItem('sep3');
		tbITB.hideItem('sep5');
		tbITB.hideItem('enable_declined');
		tbITB.hideItem('copy_scopes_sep');
		tbITB.hideItem('copy_scopes');
		tbITB.hideItem('set_response_multiple_sep');
		tbITB.hideItem('set_response_multiple');
		tbITB.hideItem('sep6');
		tbITB.hideItem('order_prints_multiple');
		tbITB.hideItem('resend_multiple_sep');
		tbITB.hideItem('resend_multiple');
		tbITB.hideItem('delete_multiple_sep');
		tbITB.hideItem('delete_multiple');
		tbITB.hideItem('copy_message_sep');
		tbITB.hideItem('copy_message');
		tbITBSearch.hideItem('export_sep');
		tbITBSearch.hideItem('export');
		tbITBSearch.showItem('add_project_contacts_sep');
		tbITBSearch.showItem('add_project_contacts');
		tbITB.showItem('cancel_add_project_contacts_sep');
		tbITB.showItem('cancel_add_project_contacts');
		jQuery('#li-project-itb').show();
		toggleTabs('li-project-itb', false);
		activateTab('li-project-itb');
	}
	else {
		tbITB.showItem('new');
		tbITB.showItem('sep2');
		tbITB.showItem('add_default');
		tbITB.showItem('sep3');
		tbITB.showItem('sep5');
		tbITB.showItem('enable_declined');
		tbITB.showItem('copy_scopes_sep');
		tbITB.showItem('copy_scopes');
		tbITB.showItem('set_response_multiple_sep');
		tbITB.showItem('set_response_multiple');
		tbITB.showItem('sep6');
		tbITB.showItem('order_prints_multiple');
		tbITB.showItem('resend_multiple_sep');
		tbITB.showItem('resend_multiple');
		tbITB.showItem('delete_multiple_sep');
		tbITB.showItem('delete_multiple');
		tbITB.showItem('copy_message_sep');
		tbITB.showItem('copy_message');
		tbITBSearch.showItem('export_sep');
		tbITBSearch.showItem('export');
		tbITBSearch.hideItem('add_project_contacts_sep');
		tbITBSearch.hideItem('add_project_contacts');
		tbITB.hideItem('cancel_add_project_contacts_sep');
		tbITB.hideItem('cancel_add_project_contacts');
		jQuery('#li-project-itb').hide();
		toggleTabs('', true);
		activateTab('li-project-contacts');
	}
}

var isPMGridInit = false;

function initAddProjectManagersDialog() {
	jQuery('#addProjectManagersDialog').dialog({
		title: 'Add Project Managers',
		modal: true,
		resizable: false,
		dialogClass: 'addProjectManagersDialog',
		width: 500,
		open: function () {
			if (!isPMGridInit)
				initProjectManagersGrid();
			else
				refreshGridProjectManagers();
		}
	});
}

var projectManagersGridMenu,
	projectManagersGrid,
	projectManagersGridTbSearch,
	projectManagersGridTbActions;
var existingProjectManagerArr = [];

function initProjectManagersGrid() {
	projectManagersGrid = new dhtmlXGridObject('projectManagersGrid');
	projectManagersGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
	projectManagersGrid.setSkin(pjqGridTheme);
	projectManagersGrid.enableAutoHeight(true);
	projectManagersGrid.enablePaging(true, 10, 3, "projectManagersGridPaging", true);
	projectManagersGrid.setPagingSkin("toolbar", "dhx_web");
	projectManagersGrid.setDragBehavior('complex');
	projectManagersGrid.setDelimiter('|');
	projectManagersGrid.enableContextMenu(projectManagersGridMenu);
	projectManagersGrid.loadXML(getGridURLProjectManagers());
	projectManagersGrid.init();

	projectManagersGrid.attachEvent("onCheckbox", function (id, ind, state) {
		var checkedRows = projectManagersGrid.getCheckedRows(0).split(',');
		if (checkedRows.length === 0)
			projectManagersGridTbActions.disableItem('add');
		else
			projectManagersGridTbActions.enableItem('add');
	});

	projectManagersGrid.attachEvent('onXLE', function () {
		for (var i = 0; i < projectContactsGrid.getRowsNum(); i++) {
			var thisRowId = parseInt(projectContactsGrid.getRowId(i));
			if (thisRowId < 0) {
				if (projectManagersGrid.getRowById(thisRowId * -1) != null)
					projectManagersGrid.cells(thisRowId * -1, 0).setValue(1);
				projectManagersGrid.cells(thisRowId * -1, 0).setDisabled(true);
			}
		}
	})

	projectManagersGridTbSearch = new dhtmlXToolbarObject("projectManagersGridToolbarSearch");
	projectManagersGridTbSearch.setSkin("dhx_web");
	projectManagersGridTbSearch.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	projectManagersGridTbSearch.addInput('searchFor', 0, '', 300);
	projectManagersGridTbSearch.addSeparator('search_sep', 1);
	projectManagersGridTbSearch.addButton("search", 2, "Search/Refresh", "action_search.gif", "");
	projectManagersGridTbSearch.attachEvent("onClick", function (id) {
		switch (id) {
			case 'search':
				refreshGridProjectManagers();
				break;
		}
	});

	projectManagersGridTbActions = new dhtmlXToolbarObject("projectManagersGridToolbarActions");
	projectManagersGridTbActions.setSkin("dhx_web");
	projectManagersGridTbActions.setIconsPath("/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxToolbar/imgs/");
	projectManagersGridTbActions.addButton("add", 1, "Add Selected", "new.gif", "new_dis.gif");
	projectManagersGridTbActions.attachEvent("onClick", function (id) {
		switch (id) {
			case 'add':
				var newContacts = projectManagersGrid.getCheckedRows(0).split(',');
				if (newContacts.length > 0) {
					PanteraScript.PanteraScriptService.AddProjectManagersToProject(pjqSessionId, project.ProjectId, newContacts.join(','), AddProjectManagersToProjectC, onScriptError);
				}
				break;
		}
	});
}

function AddProjectManagersToProjectC(response) {
	if (response) {
		refreshGridProjectContacts();
		jQuery('#addProjectManagersDialog').dialog('close');
	}
	else {
		//error
	}
}

function refreshGridProjectManagers() {
	projectManagersGrid.clearAndLoad(getGridURLProjectManagers());
}

function getGridURLProjectManagers() {
	var response = '/DesktopModules/PJQProjectWallAdmin/GetPMGrid.aspx?sessionId=' + pjqSessionId;

	if (projectManagersGridTbSearch != null) {
		var pmSearchFor = projectManagersGridTbSearch.getValue('searchFor').trim();
		if (pmSearchFor.length > 0)
			response += '&s=' + pmSearchFor;
	}

	return response;
}

function toggleUserSeats() {

	var addList = [], deleteList = [];

	var statusColumn = projectContactsGrid.getColumnCount() - 1;
	for (var i = 0; i < projectContactsGrid.getRowsNum(); i++) {
		if (projectContactsGrid.cells2(i, 0).getValue() == 1) {
			var pcId = parseInt(projectContactsGrid.getRowId(i).toString());
			if (pcId > 0) {
				// check if add or delete
				if (projectContactsGrid.cells(pcId, statusColumn).getValue() == 'Yes')
					deleteList.push(pcId);
				else if (projectContactsGrid.cells(pcId, statusColumn).getValue() == 'No')
					addList.push(pcId);
			}
		}
	}
	if (addList.length > 0)
		addUserSeats(addList.join(','));

	if (deleteList.length > 0)
		deleteUserSeats(deleteList.join(','));
}

function addUserSeats(idList) {
	PanteraScript.PanteraScriptService.AddUserSeats(pjqSessionId, idList, function () {
		var ids = idList.split(',');
		var statusColumn = projectContactsGrid.getColumnCount() - 1;
		for (var i = 0; i < ids.length; i++) {
			projectContactsGrid.cells(parseInt(ids[i]), statusColumn).setValue('Yes');
		}
	}, onScriptError);
}

function deleteUserSeats(idList) {
	PanteraScript.PanteraScriptService.DeleteUserSeats(pjqSessionId, idList, function () {
		var ids = idList.split(',');
		var statusColumn = projectContactsGrid.getColumnCount() - 1;
		for (var i = 0; i < ids.length; i++) {
			projectContactsGrid.cells(parseInt(ids[i]), statusColumn).setValue('No');
		}
	}, onScriptError);
}

function InitializeSeatCheckGrid(contactIdList, successCallback) {

	var xmlFile = '/DesktopModules/PJQProjectWallAdmin/GetPCGrid.aspx?sessionid=' + pjqSessionId + '&schk=' + contactIdList + '&x=' + (new Date).getTime();

	jQuery.ajax({
		url: xmlFile,
		dataType: 'text',
		success: function (result) {
			// check result text for rows
			if (result.indexOf('<row id') != -1) {
				jQuery('#seatChooserDialog').dialog({
					title: 'User Seats Required - Select Seats to Add',
					modal: true,
					resizable: false,
					dialogClass: 'fieldReportChooserDialog',
					width: 700,
					height: 550,
					position: 'top',
					open: function (e, ui) {
						seatCheckGrid = new dhtmlXGridObject('seatChooserGrid');
						seatCheckGrid.setImagePath('/DesktopModules/PanteraModuleGlobal/dhtmlx/3/5/eval/dhtmlxgrid/imgs/');
						seatCheckGrid.setSkin(pjqGridTheme);
						seatCheckGrid.enableAutoHeight(true);
						seatCheckGrid.enablePaging(true, 10, 3, "seatChooserGridPaging", true);
						seatCheckGrid.setPagingSkin("toolbar", "dhx_web");
						seatCheckGrid.init();
						seatCheckGrid.parse(result, 'xml');
						seatCheckGrid.setCheckedRows(0, 1);
					},
					buttons: {
						"Continue": function () {
							jQuery('#seatChooserDialog').dialog('close');

							// get list of checked rows and call method, handler calls successmethod.
							var list = seatCheckGrid.getCheckedRows(0);
							if (list && list.length > 0)
								PanteraScript.PanteraScriptService.AddUserSeats(pjqSessionId, list, successCallback, onScriptError);
							else
								successCallback();
						}
					}
				});
			}
			else
				successCallback();

		},
		error: function (xhr, status, error) {
			showInfoDialogPWall('System Error', "An error occurred while preparing to save: " + error, 'ui-icon-alert');
		}
	});

}
